import httpClient from './httpClient'

export interface IPlanningCounts {
  ongoing: number
  upcoming: number
  past: number
}

export interface INextEvent {
  id: number
  planning_name: string
  location: string
  exhibition_start_date: string
  exhibition_end_date: string
  days_until_setup: number
  booth_number: string
  items_count: number
  is_complete: boolean
  missing: string[]
}

export type OpenTaskType = 'incomplete_plan' | string

export interface IOpenTask {
  type: OpenTaskType
  planning_id: number
  title: string
  status: string
  missing: string[]
  due_date: string | null
}

export interface IMasterData {
  active_projects: number
  items: number
  categories: number
  active_team_members: number
}

const DashboardService = {
  async getPlanningCounts(): Promise<IPlanningCounts> {
    const response = await httpClient.get('/dashboard/customer/planning_counts')
    return response.data
  },

  async getNextEvent(): Promise<INextEvent | null> {
    const response = await httpClient.get('/dashboard/customer/next_appearance')
    return response.data ?? null
  },

  async getOpenTasks(): Promise<IOpenTask[]> {
    const response = await httpClient.get('/dashboard/customer/open_tasks')
    return response.data ?? []
  },

  async getMasterData(): Promise<IMasterData> {
    const response = await httpClient.get('/dashboard/customer/master_data')
    return response.data
  },
}

export default DashboardService
